import React from 'react';
import { useLocation } from 'react-router-dom';
import './App.css';

import RootOnwrApp from './RootOnwrApp';
import RootOnwrMap from './RootOnwrMap';

export default function App() {
  const location = useLocation();

  const basePath = `/${process.env.REACT_APP_PATH || ''}`.replace(/\/+$/, '');
  const { pathname } = location;

  if (pathname === '/'
  || pathname === ''
  || pathname === '/main'
  || pathname === basePath
  || pathname === `${basePath}/`
  || pathname === `${basePath}/main`) {
    return (<RootOnwrMap />);
  }

  return (<RootOnwrApp />);
}
